/// <reference path="../../adpIntegration/sections/adpIntegration.main.section.ts" />

module Meevo.Plugins.AdpWfnIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class WfnMainSection extends Meevo.Plugins.AdpIntegration.MainSection {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            busyService: Meevo.Components.Busy.IBusyService,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                modalService,
                busyService,
                sectionSecurityKey);

            this.integrationStage = -1;             
        }

        private integrationStage: number;

        rollbackChanges(): void {
            super.rollbackChanges();
            this.integrationStage = -1;
        }

        activate(): void {
            super.activate();
            if (this.readyForCompanyCodeSetupProcess() && this.needCompanyCodeSetupProcess() && this.model.companyCodeList.length == 0)
                this.modalService.warning("WFN_EMPTY_COMPANYCODE_LIST");
        }

        needConnectorIdSetupProcess(): boolean {
            return _.isUndefined(this.model.connectorId) || this.model.connectorId == '';
        }

        readyForCompanyCodeSetupProcess(): boolean {
            return this.model.consentCompleted && this.needCompanyCodeSetupProcess() && !this.needConnectorIdSetupProcess();
        }

        needCompanyCodeSetupProcess(): boolean {
            return _.isUndefined(this.model.adpCompanyCode) || this.model.adpCompanyCode == '';
        }

        CanChangeIntegrationStatus(): boolean {
            return this.model.isAdpMarketplaceSubscriptionActive &&
                this.model.consentCompleted && this.model.canEnableStatus &&
                Model.Guard.isSomething(this.model.adpCompanyCode) && this.model.adpCompanyCode.length > 0;
        }
   }

}